<template>
  <ReportBaseSelectFilter
    class="tracked-time-filter"
    label="Tracked time"
    placeholder="With tracked time"
    query-property="tracked_time"
    :options="trackedTimeOptions"
    multiple
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReportTrackedTimeFilter',
  computed: {
    ...mapGetters(['trackedTimeOptions']),
  },
};
</script>
